import { render, staticRenderFns } from "./TopicFaqModelListDialog.vue?vue&type=template&id=9b9bc222&"
import script from "./TopicFaqModelListDialog.vue?vue&type=script&lang=js&"
export * from "./TopicFaqModelListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports